import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import "./libraries/i18n.ts";
import "./libraries/luxon.ts";
import "./libraries/chartjs.ts";
import "./libraries/katex.ts";
import "./libraries/analytics";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
